import { tva } from "@gluestack-ui/utils/nativewind-utils";

export const discreteSliderStyle = tva({
  base: "justify-center items-center",
  variants: {
    orientation: {
      horizontal: "w-full",
      vertical: "h-full",
    },
    size: {
      sm: "",
      md: "",
      lg: "",
    },
  },
});

export const discreteSliderTrackStyle = tva({
  base: "bg-background-500 rounded-lg overflow-hidden",
  variants: {
    orientation: {
      horizontal: "w-full h-[2px]",
      vertical: "h-full w-[2px]",
    },
  },
});

export const discreteSliderThumbStyle = tva({
  base: "bg-primary-500 absolute rounded-full data-[focus=true]:bg-primary-600 data-[active=true]:bg-primary-600 data-[hover=true]:bg-primary-600 data-[disabled=true]:bg-primary-500 web:cursor-pointer web:active:outline-4 web:active:outline web:active:outline-primary-400 data-[focus=true]:web:outline-4 data-[focus=true]:web:outline data-[focus=true]:web:outline-primary-400 shadow-hard-1",
  variants: {
    size: {
      sm: "h-4 w-4",
      md: "h-5 w-5",
      lg: "h-6 w-6",
    },
  },
});

export const discreteSliderStepStyle = tva({
  base: "bg-background-500 absolute bottom-0",
  parentVariants: {
    size: {
      sm: "w-[2px] h-2 -translate-x-[1px]",
      md: "w-[3px] h-2 -translate-x-[1.5px]",
      lg: "w-[4px] h-2 -translate-x-[2px]",
    },
  },
});
